"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QuickContactCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground-light mb-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Ready to Protect Your Property?
        </h2>

        <div className={`flex flex-col sm:flex-row items-center justify-center gap-[5%] w-full transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild className="w-full sm:w-[45%] h-14 text-lg font-semibold bg-primary text-foreground-primary hover:bg-primary-hover active:bg-primary-active shadow-soft hover:shadow-medium transition-all duration-[var(--duration-fast)] hover:scale-[1.02] focus-visible:ring-2 focus-visible:ring-ring rounded-md">
            <Link to="tel:CallMike">Call Mike Directly</Link>
          </Button>

          <Button asChild className="w-full sm:w-[45%] h-14 text-lg font-semibold bg-primary text-foreground-primary hover:bg-primary-hover active:bg-primary-active shadow-soft hover:shadow-medium transition-all duration-[var(--duration-fast)] hover:scale-[1.02] focus-visible:ring-2 focus-visible:ring-ring rounded-md">
            <Link to="/ContactPage">Request Service</Link>
          </Button>
        </div>
      </div>
    </section>;
}